<template>
  <div id="component">

    <a class="twitter-timeline" data-lang="sv" data-width="340" data-height="500" :href="'https://twitter.com/' + id">Tweets by {{id}}</a>

  </div>
</template>

<script>
export default {
  name: 'FeedTwitter',
  data () {
    return {
    }
  },
  props: {
    id: "",
    alt: ""
  },
  methods: {
  },
  computed: {
  },
  mounted: function () {

    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = 'https://platform.twitter.com/widgets.js';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'twitter-jssdk'));


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  #component{
  }

</style>



// WEBPACK FOOTER //
// src/components/FeedTwitter.vue